var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w3-display-container w3-center w3-margin w3-padding-64"},[_c('div',{staticClass:"w3-display-bottom-middle"},[_c('loading',{attrs:{"dspin":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }